export const hasCompleteVariantDetails = (product) => {
  if (!product?.has_variants) return true;
  const hasVariantKeys =
    Array.isArray(product.variant_keys) &&
    product.variant_keys.some(
      (variant) => variant && `${variant.variant_key || ""}`.trim(),
    );
  return (
    hasVariantKeys &&
    Array.isArray(product.children) &&
    product.children.length > 0
  );
};

export const shouldHydrateProductDetails = (previousProduct, product) => {
  if (!product) return false;
  const detailsIncomplete =
    !product.has_loaded || !hasCompleteVariantDetails(product);
  if (!detailsIncomplete) return false;
  return Boolean(
    !previousProduct ||
      previousProduct.id !== product.id ||
      (previousProduct.has_loaded === true && !product.has_loaded),
  );
};
